import reducer from "./reducer";
export { default as GeneralValues } from "./components/index";
export { default as generalValuesReducerName } from "./constants";
export default reducer;
